<template>
  <div>
    <b-navbar
      toggleable="lg"
      type="dark"
      class="p-0 customnavx customnavmanagex"
      :class="$style.navbarHeader"
    >
      <b-navbar-brand class="py-2 px-3 m-0" :class="$style.backgroundLogo">
        <b-link :to="'/home'"
          ><b-img
            fluid
            src="@assets/images/xactus_logo.png"
            :class="$style.img"
            class="mx-auto py-1"
          ></b-img
        ></b-link>
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav :class="$style.navBarParent">
          <ul id="menu" class="p-0">
            <BaseNavspinner v-if="showSpinner"></BaseNavspinner>
            <template v-for="data in getMenuData">
              <RootMenu
                :key="data.id"
                :menu="data"
                :json-data="menu.mainMenu"
                :menu-level="1"
              ></RootMenu>
            </template>
          </ul>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item v-if="isNotProdEnvironment">
            <span class="text-white" :class="$style.mainheadName">{{
              currentEnvironment
            }}</span>
          </b-nav-item>
          <Notifications v-if="enableNotification && isHMDAUser" />
          <b-nav-item-dropdown right>
            <template slot="button-content">
              <div class="d-inline-block pr-2 text-white">
                <p class="text-white" :class="$style.mainheadName">
                  {{ userName }}
                </p>
                <p :class="$style.mainheadEmail">
                  {{ customerName }}
                </p>
              </div>
            </template>

            <template v-for="(data, index) in getProfileMenuData">
              <b-dropdown-item :key="data.id" :class="$style.dropdownItem">
                <b-link
                  v-if="data.id === 179"
                  class="text-dark"
                  @click="logout"
                  >{{ data.apiScopeName }}</b-link
                ><b-link
                  v-else-if="data.id === 177"
                  class="text-dark"
                  @click="openClose"
                  >{{ data.apiScopeName }}</b-link
                >
                <b-link v-else class="text-dark" :to="getRoutes(data.id)">{{
                  data.apiScopeName
                }}</b-link>
              </b-dropdown-item>
              <b-dropdown-divider
                v-if="index !== getProfileMenuData.length - 1"
                :key="data.id + 'div'"
                class="m-0"
              />
            </template>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import RootMenu from './RootMenu.vue'
import constant from '@constants/navbarRoutes'
import {
  navbarMethods,
  toasterMethods,
  broadcastActions,
  notificationGetters,
} from '@state/helpers'
import getSavedState from '@utils/get-state.js'
import constants from '@constants/constant'
import Notifications from '../NavBar/Notifications.vue'
import { hmdaACL } from '@/src/utils/accesslevels'

export default {
  components: { RootMenu, Notifications },
  data() {
    return {
      userName: '',
      customerName: '',
      routing: constant.navRoutes,
      menu: [],
      showSpinner: false,
      isHMDAUser: false,
    }
  },
  computed: {
    ...notificationGetters,
    getMenuData() {
      return this.menu && this.menu.mainMenu
        ? this.menu.mainMenu.filter((x) => x && !x.parentId)
        : []
    },
    isNotProdEnvironment() {
      return process.env.VUE_APP_ENV_NAME !== '[PROD]'
    },
    getProfileMenuData() {
      return this.menu && this.menu.profileMenu ? this.menu.profileMenu : []
    },
    currentEnvironment() {
      return process.env.VUE_APP_ENV_NAME
    },
  },
  created() {
    if (!getSavedState('menu')) {
      this.getNavMenus()
    } else {
      this.menu = getSavedState('menu')
    }
  },
  async mounted() {
    this.$startBroadcastConnection()
    await this.getUserDetails()
    this.isHMDAUser = hmdaACL.isHMDAUser()
  },
  methods: {
    ...broadcastActions,
    ...navbarMethods,
    ...toasterMethods,
    /* eslint-disable no-undef */
    getNavMenus() {
      this.showSpinner = true
      this.getNavMenu()

        .then((response) => {
          if (response && response.data) {
            this.$store.commit('auth/SET_MENUAPI_CALLS', 0)
            // push 'MyQueue' to last
            let source = response.data[0] || {}
            let menu = source.mainMenu || []

            let qIndex = menu.findIndex((i) => i.id === 135)
            if (qIndex) {
              let mQ = menu.splice(qIndex, 1)[0]
              menu.push(mQ)
            }

            source.mainMenu = menu

            localStorage.setItem('menu', JSON.stringify(source))
            this.menu = response.data[0]
            this.showSpinner = false
          }
        })
        .catch((error) => {
          let msg = ''
          if (error.response.status === 500) {
            let menuAPITries = this.$store.getters['auth/menuAPITries']
            if (menuAPITries < 1) {
              this.getNavMenus()
              this.$store.commit(
                'auth/SET_MENUAPI_CALLS',
                this.$store.getters['auth/menuAPITries'] + 1
              )
            } else {
              msg = 'Login failed, please logout and login again'
            }
          } else if (error.response.status === 401) {
            msg = 'Auth failed'
            this.$router.push({
              name: 'login',
            })
          } else if (error.response.status === 400) {
            msg = 'request malformed'
          }
          this.setAlert({
            title: constants.imageHeaderError,
            msg: msg || constants.errorMessage,
            variant: constants.errorMessagetype,
          })
        })
    },
    openClose() {
      if (window.screen.width < 1025) {
        window.open(frameURL, '_blank')
      } else {
        var yanaApp = document.getElementById('yana-wrapper')
        var appHeader = document.getElementById('yana-app-header')
        var leftText = document.getElementById('yana-left-text')
        var rightText = document.getElementById('yana-right-text')
        var iframe = document.getElementById('yana-app-wrapper')
        var headerText = document.getElementById('yana-top-paragraph')
        var yanaBottomButton = document.getElementById('yana-bottom-button')
        if (yanaApp.style.display === 'none') {
          if (isInitialLoad) iframe.setAttribute('src', frameURL)
          isInitialLoad = false
          yanaApp.style.display = 'block'
          appHeader.style.width = topButtonWidth
          appHeader.style.right = '0px'
          appHeader.style.height = topButtonHeight
          appHeader.style.backgroundColor = topBackgroundColor
          leftText.style.display = 'block'
          headerText.style.paddingLeft = '24px'
          headerText.style.textAlign = 'left'
          rightText.style.display = 'block'
          yanaBottomButton.style.display = 'none'
          rightText.focus()
        } else {
          yanaApp.style.display = 'none'
          appHeader.style.width = bottomButtonWidth
          appHeader.style.right = '-175px'
          appHeader.style.height = bottomButtonHeight
          appHeader.style.backgroundColor = bottomButtonColor
          leftText.style.display = 'block'
          rightText.style.display = 'none'
          headerText.style.textAlign = 'center'
          headerText.style.paddingLeft = '0px'
          yanaBottomButton.style.display = 'block'
          yanaBottomButton.focus()
        }
      }
    },
    logout() {
      this.$router.push({ path: '/' })
      localStorage.clear()
      this.$store.commit('masterData/RESET_MASTER_DATA')
      this.$store.commit('saveSearchModule/saveSearch', null)
      this.$store.commit('reports/SET_CURRENT_PAGE', 0)
      this.$store.commit('reports/SET_REPORTS', [])
      this.$store.commit('reports/SET_SELECTED_ROW', 0)
      this.$stopBroadcastConnection()
    },
    getRoutes(id) {
      return this.routing.find((x) => x.id === id)
        ? this.routing.find((x) => x.id === id).route
        : ''
    },
    getUserDetails() {
      if (!this.$store) return false
      this.userInfo = this.$store.state.auth.currentUser.userInfo
      if (this.userInfo) {
        var middleName =
          this.userInfo.middleInitial != null ? this.userInfo.middleInitial : ''
        this.userName =
          this.userInfo.firstName +
          ' ' +
          middleName +
          ' ' +
          this.userInfo.lastName
        this.userEmail = this.userInfo.emailAddress
        this.customerName = this.userInfo.customerName
      }
    },
  },
}
</script>
<style lang="scss" module>
@import '@design';

.navBarParent > ul > li:hover {
  color: #fff;
  background-color: #06c;
}

.navBarParent > ul > li > ul > li:hover {
  font-weight: 600;
  background-color: #f1f1f1;
}

.navbarHeader {
  padding: 3px 10px;
  background-color: #1e3866;
}

.dropdownItem {
  display: block;
  width: 100%;
  padding: 0;
  clear: both;
  font-weight: $content-font-weight;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.img {
  width: 160px;
}

.backgroundLogo {
  background: #fff;
}

.mainheadName {
  margin-bottom: 0;
  font-size: $size-content-font-xm;
  font-weight: $label-font-weight-lg;
}

.mainheadEmail {
  position: relative;
  margin-right: 0;
  margin-bottom: 0;
  font-size: $size-content-font-xm;
  color: #dadada;
}

.dropWhite a span {
  color: #fff !important;
}
</style>
